export default __webpack_public_path__ + "static/media/mg-2-lqMAX.7d2b3370.avif";